import { useState } from "react";
import apiClient from "../../../shared/API/apiClient";
import "../../../styles/components/deleteModal.css";

const DeptDeleteModal = ({
  record,
  idKey,
  nameKey,
  endpoint,
  onClose,
  onDeleted,
}) => {
  const [status, setStatus] = useState("idle");
  const [apiError, setApiError] = useState("");

  const handleDelete = async () => {
    setStatus("loading");
    setApiError("");

    const id = record?.[idKey];

    if (!id) {
      setApiError("Could not find ID. Please refresh and try again.");
      setStatus("error");
      return;
    }

    try {
      // FIX: URL me ID append karo
      const response = await apiClient.delete(`${endpoint}/${id}`);

      if (response.data.code === 200) {
        onDeleted(id);
      } else {
        throw new Error(response.data.message || "Delete failed");
      }
    } catch (err) {
      console.error("Delete error:", err);

      const msg =
        err.response?.data?.message ||
        err.message ||
        "Something went wrong.";

      setApiError(msg);
      setStatus("error");
    }
  };

  const isLoading = status === "loading";

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-box modal-box--sm delete-modal-box"
        onClick={(e) => e.stopPropagation()}
      >
        <center>
          <p className="delete-modal-text">
            Are you sure you want to delete?
            <br />
            This action <strong>cannot be undone.</strong>
          </p>
        </center>

        {apiError && (
          <div className="delete-modal-error">✕ {apiError}</div>
        )}

        <div className="delete-modal-actions">
          <button
            className="org-btn-cancel"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>

          <button
            onClick={handleDelete}
            disabled={isLoading}
            className="delete-btn"
          >
            {isLoading ? "Deleting…" : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeptDeleteModal;